import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Reaction, Resource, StickerReactionPayload } from '@yandex-int/k-common';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import { Sticker, StickersStoreState, StudentsReactions } from './typings';

const initialState: StickersStoreState = {
    clessonMetaStickers: [],
    clessonStudentsStickers: {},
    stickerResources: {},
    stickerResourcesLoadingStatus: {},
};

const createClessonStudentsStickers = (reactions: Reaction<StickerReactionPayload>[]) => {
    return reactions.reduce((result, reaction) => {
        const studentId = reaction.receiver_id;
        result[studentId] = reaction;

        return result;
    }, {} as StudentsReactions);
};

// экшны нужны для саги
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function */
const slice = createSlice({
    name: 'STICKERS',
    initialState: initialState,
    reducers: {
        getClessonMetaStickersRequest: (
            state: StickersStoreState,
            action: PayloadAction<{ stickerSlugs: string[] }>
        ) => {
            state.clessonMetaStickers = [];
        },
        resetClessonMetaStickers: (state: StickersStoreState) => {
            state.clessonMetaStickers = [];
        },
        getClessonMetaStickersSuccess: (state: StickersStoreState, action: PayloadAction<{ stickers: Sticker[] }>) => {
            state.clessonMetaStickers = action.payload.stickers;
        },
        getClessonStudentsStickersRequest: (
            state: StickersStoreState,
            action: PayloadAction<{ clessonId: number }>
        ) => {
            state.clessonStudentsStickers = {};
        },
        getClessonStudentsStickersSuccess: (
            state: StickersStoreState,
            action: PayloadAction<{ reactions: Reaction<StickerReactionPayload>[] }>
        ) => {
            const { reactions } = action.payload;
            state.clessonStudentsStickers = createClessonStudentsStickers(reactions);
        },
        assignClessonStudentsSticker: (
            state: StickersStoreState,
            action: PayloadAction<{
                clessonId: number;
                courseId: number;
                slug: string;
                studentIds: number[];
            }>
        ) => {
            // saga
        },
        assignClessonStudentsStickerSuccess: (
            state: StickersStoreState,
            action: PayloadAction<{ reactions: Reaction<StickerReactionPayload>[] }>
        ) => {
            const { reactions } = action.payload;
            const clessonStudentsStickers = createClessonStudentsStickers(reactions);
            state.clessonStudentsStickers = {
                ...state.clessonStudentsStickers,
                ...clessonStudentsStickers,
            };
        },
        cancelClessonStudentsSticker: (
            state: StickersStoreState,
            action: PayloadAction<{ reactionIds: string[]; studentIds: number[] }>
        ) => {
            const { studentIds } = action.payload;
            const clessonStudentsStickers = { ...state.clessonStudentsStickers };
            studentIds.forEach((studentId) => {
                delete clessonStudentsStickers[studentId];
            });
            state.clessonStudentsStickers = clessonStudentsStickers;
        },
        getStickerResourcesRequest: (state: StickersStoreState, action: PayloadAction<{ resourceIds: number[] }>) => {
            const { resourceIds } = action.payload;
            const next = resourceIds.reduce(
                (result, id) => {
                    result[id] = LOADING_STATUSES.LOADING;
                    return result;
                },
                {} as Record<number, LOADING_STATUSES>
            );
            state.stickerResourcesLoadingStatus = {
                ...state.stickerResourcesLoadingStatus,
                ...next,
            };
        },
        getStickerResourcesRequestSuccess: (
            state: StickersStoreState,
            action: PayloadAction<{ resources: Resource[] }>
        ) => {
            const stickerResourcesLoadingStatus: Record<number, LOADING_STATUSES> = {};
            const stickerResources: Record<number, Resource> = {};
            const { resources } = action.payload;
            resources.forEach((resource) => {
                stickerResourcesLoadingStatus[resource.id] = LOADING_STATUSES.SUCCESS;
                stickerResources[resource.id] = resource;
            });
            state.stickerResourcesLoadingStatus = {
                ...state.stickerResourcesLoadingStatus,
                ...stickerResourcesLoadingStatus,
            };
            state.stickerResources = {
                ...state.stickerResources,
                ...stickerResources,
            };
        },
    },
});
/* eslint-enable @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function */

export const stickersActions = slice.actions;
export const stickersReducer = slice.reducer;
